import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, of } from 'rxjs';
import { catchError, filter, take, timeout } from 'rxjs/operators';
import { selectActor } from '../store/auth/auth.selectors';

export const subpartnerActorGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    const actor = await firstValueFrom(
        store.select(selectActor).pipe(
            filter((value) => value !== null && value !== undefined),
            take(1),
            timeout(3000),
            catchError(() => of(null))
        )
    );

    const roleCode = String(actor?.role_code || '').trim().toLowerCase();
    if (roleCode === 'subpartner' && actor?.actor_type === 'org') return true;
    if (roleCode === 'sales') return router.parseUrl('/developer/dashboard');
    if (roleCode === 'app_admin') return router.parseUrl('/admin/dashboard');
    if (actor?.actor_type === 'investor') return router.parseUrl('/properties');
    return router.parseUrl('/developer/dashboard');
};

export { subpartnerActorGuard as partnerActorGuard };
